// extracted by mini-css-extract-plugin
export default {"chip":"RoleChip_chip__Xp+LA","admin":"RoleChip_admin__qqX9T","clinic":"RoleChip_clinic__xm+Ul","doctor":"RoleChip_doctor__F8qbc","read_only":"RoleChip_read_only__k2B4M"};